import { fadeIn, fadeInUp } from '@/constants/motions';
import LightboxImage from '@/ui/LightboxImage';
import { motion } from 'framer-motion';

export default function CertificateBeside({ title, image, children, subtitle }) {
  return (
    <section className="my-16 px-4">
      <div className="container-screen">
        <motion.div
          className="grid items-center gap-8 lg:grid-cols-2"
          initial="hidden"
          transition={{
            ...fadeIn.transition,
            when: 'beforeChildren',
            staggerChildren: 0.4,
          }}
          variants={fadeIn}
          viewport={fadeIn.viewport}
          whileInView="visible"
        >
          <motion.div className="relative max-w-screen-sm pb-10 md:order-2" variants={fadeInUp}>
            <div className="absolute bottom-0 h-20 w-full rounded-lg bg-primary-600"></div>
            <div className="flex justify-evenly gap-4 px-6">
              <LightboxImage
                alt="Letter of Appointment"
                className="relative aspect-[3/4] h-full w-9/12 cursor-pointer overflow-hidden object-cover shadow-lg transition duration-200 hover:-translate-y-2 hover:shadow-xl"
                layout="fill"
                object-fit="cover"
                src={image}
              />
            </div>
          </motion.div>
          <motion.div variants={fadeInUp}>
            <motion.div className="order-1" variants={fadeInUp}>
              {subtitle && <h3 className="text-xl text-primary-500 lg:text-2xl">{subtitle}</h3>}
              {typeof title === 'string' ? (
                <h2 className="mt-4 text-3xl md:text-4xl xl:text-5xl">{title}</h2>
              ) : (
                title
              )}
              <div className="prose prose-neutral mt-6 max-w-none leading-normal">{children}</div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
